//创意状态
const adcreativeStatus = [
  {value: '1',  label: '计划已暂停'},
  {value: '3',  label: '计划超预算'},
  {value: '6',  label: '余额不足'},
  {value: '11',  label: '组审核中'},
  {value: '12',  label: '组审核未通过'},
  {value: '14',  label: '已结束'},
  {value: '15',  label: '组已暂停'},
  {value: '17',  label: '组超预算'},
  {value: '19',  label: '未达投放时间'},
  {value: '22',  label: '不在投放时段'},
  {value: '41',  label: '审核中'},
  {value: '42',  label: '审核未通过'},
  {value: '46',  label: '已暂停'},
  {value: '52',  label: '投放中'},
  {value: '53',  label: '作品异常'},
  {value: '-2',  label: '所有包含已删除'},
  {value: '40',  label: '只包含已删除不传'},
]

//素材类型
const materialType = [
  {label: '竖屏视频', value: '1'},
  {label: '横屏视频', value: '2'},
  {label: '便利贴', value: '3'},
]

export default {
  adcreativeStatus,
  materialType
}